(function(){
  'use strict';

  function isMobileTablet(){
    return window.matchMedia ? window.matchMedia('(max-width:1024px)').matches : window.innerWidth <= 1024;
  }
  function q(root,sel){return (root||document).querySelector(sel);}
  function qa(root,sel){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function esc(value){return String(value||'').replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];});}
  function normaliseStoreName(name){
    var key=String(name||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/^labosch\s+/,'').replace(/[\s:;,._\-–—]+/g,'').trim();
    if(key==='hq'||key==='central'||key==='laboschhq'||key==='laboschcentral')return 'laboschcentral';
    return key;
  }

  function readStoreRows(panel){
    var list=panel&&q(panel,'[data-lbx-store-stock-list]');
    if(!list)return [];
    var unique={};
    qa(list,'.lbx-store-stock__row').forEach(function(row){
      var nameEl=q(row,'b');
      var noteEl=q(row,'small');
      var qtyEl=q(row,':scope > strong');
      var item={
        name:nameEl?String(nameEl.textContent||'').trim():'',
        note:noteEl?String(noteEl.textContent||'').trim():'',
        qty:qtyEl?String(qtyEl.textContent||'').trim():''
      };
      if(!item.name&&!item.qty)return;
      var key=normaliseStoreName(item.name)||'stock';
      if(!unique[key]){unique[key]=item;return;}
      var oldQty=parseInt(String(unique[key].qty||'').replace(/\D+/g,''),10)||0;
      var newQty=parseInt(String(item.qty||'').replace(/\D+/g,''),10)||0;
      if(newQty>oldQty)unique[key]=item;
    });
    return Object.keys(unique).map(function(key){return unique[key];});
  }

  function closeMobileStoreModal(){
    qa(document,'.lbx78-store-modal[data-lbx105-store-modal]').forEach(function(modal){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      window.setTimeout(function(){if(modal.parentNode)modal.parentNode.removeChild(modal);},210);
    });
    document.body.classList.remove('lbx78-store-modal-open');
    qa(document,'.lbx-store-stock-chip__trigger[aria-expanded="true"]').forEach(function(btn){btn.setAttribute('aria-expanded','false');});
  }

  function openMobileStoreModal(trigger){
    if(!isMobileTablet()||!trigger)return;
    var panel=trigger.closest('[data-lbx-store-stock-panel]');
    if(!panel)return;
    var rows=readStoreRows(panel);
    if(!rows.length)return;

    /* Remove the legacy V78 instance if it was mounted inside the product.
       A body-level fixed sheet cannot be clipped by any PDP container. */
    qa(document,'.lbx78-store-modal').forEach(function(old){if(old.parentNode)old.parentNode.removeChild(old);});

    var summary=q(panel,'[data-lbx-store-stock-summary]');
    var summaryText=summary?String(summary.textContent||'').trim():'';
    if(!summaryText)summaryText=rows.length===1?'1 tienda con stock':rows.length+' tiendas con stock';

    var modal=document.createElement('div');
    modal.className='lbx78-store-modal';
    modal.setAttribute('data-lbx105-store-modal','');
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML=''+
      '<button type="button" class="lbx78-store-modal__backdrop" data-lbx105-store-close aria-label="Cerrar"></button>'+
      '<section class="lbx78-store-modal__sheet" role="dialog" aria-modal="true" aria-label="Disponibilidad por tienda">'+
        '<div class="lbx78-store-modal__handle" aria-hidden="true"></div>'+
        '<div class="lbx78-store-modal__head">'+
          '<span><strong>Disponibilidad por tienda</strong><small>'+esc(summaryText)+'</small></span>'+
          '<button type="button" class="lbx78-store-modal__close" data-lbx105-store-close aria-label="Cerrar">×</button>'+
        '</div>'+
        '<div class="lbx78-store-modal__list">'+rows.map(function(row){
          return '<div class="lbx-store-stock__row"><span><b>'+esc(row.name)+'</b>'+(row.note?'<small>'+esc(row.note)+'</small>':'')+'</span><strong>'+esc(row.qty)+'</strong></div>';
        }).join('')+'</div>'+
      '</section>';
    document.body.appendChild(modal);
    trigger.setAttribute('aria-expanded','true');
    document.body.classList.add('lbx78-store-modal-open');
    requestAnimationFrame(function(){modal.classList.add('is-open');modal.setAttribute('aria-hidden','false');});
    qa(modal,'[data-lbx105-store-close]').forEach(function(btn){btn.addEventListener('click',closeMobileStoreModal);});
    var close=q(modal,'.lbx78-store-modal__close');
    if(close)window.setTimeout(function(){try{close.focus({preventScroll:true});}catch(e){close.focus();}},50);
  }

  /* Capture before the legacy V78 listener. Its old open() can abort when the
     panel visibility changes during variant initialisation; V105 reads the
     live populated rows directly and always mounts the modal in <body>. */
  document.addEventListener('click',function(event){
    if(!isMobileTablet())return;
    var trigger=event.target.closest&&event.target.closest('.lbx-store-stock-chip__trigger');
    if(!trigger)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openMobileStoreModal(trigger);
  },true);

  document.addEventListener('keydown',function(event){
    if(event.key==='Escape')closeMobileStoreModal();
  });
})();
